import React from 'react';
import { useGetCompanyInfo } from '../../../../hooks';

const ChimeIdentification = () => {
  const companyInfo = useGetCompanyInfo();

  return (
    <>
      {companyInfo.data?.amazonTeamAccountId && (
        <>
          <div
            className="pa-acc-info__label"
            data-testid="PlatformAdminUI-AccountInfo-CompanyInfo-AmazonTeamIdLabel"
          >
            AMAZON TEAM ID
          </div>
          <div
            className="pa-acc-info__text"
            data-testid="PlatformAdminUI-AccountInfo-CompanyInfo-AmazonTeamId"
          >
            {companyInfo.data?.amazonTeamAccountId}
          </div>
        </>
      )}
    </>
  );
};

export default ChimeIdentification;
